import { useSelector } from "react-redux";

import { getLivestockSaleId } from "lib/navigation";
import { getVendorSplitKey } from "lib/vendorSplits";

import {
  getDescriptionBySplitId,
  selectVendorSplitByKeyLookup,
} from "selectors";

export const useGetBestMatchingVendorSplit = ({
  primaryBusinessId,
  deploymentId,
  consignmentId,
  saleLotId,
}) => {
  const saleLotSplitKey = saleLotId
    ? getVendorSplitKey({
        primaryBusinessId,
        deploymentId,
        livestockSaleId: getLivestockSaleId(),
        saleLotId,
      })
    : null;

  const consignmentSplitKey = getVendorSplitKey({
    primaryBusinessId,
    deploymentId,
    livestockSaleId: getLivestockSaleId(),
    consignmentId,
  });

  const saleSplitKey = getVendorSplitKey({
    primaryBusinessId,
    deploymentId,
    livestockSaleId: getLivestockSaleId(),
  });
  const vendorSplitByKeyLookup = useSelector(selectVendorSplitByKeyLookup);

  const bestSplit =
    vendorSplitByKeyLookup[saleLotSplitKey] ||
    vendorSplitByKeyLookup[consignmentSplitKey] ||
    vendorSplitByKeyLookup[saleSplitKey];

  const splitDescription = useSelector(getDescriptionBySplitId(bestSplit?.id));

  return [bestSplit, splitDescription];
};
